"use strict";

module.exports = {
  strings: {
    pluginNameDropbox: 'Dropbox'
  }
};